import React from 'react';

// Real brand logos as inline SVG components for reliability
export function AmazonLogo({ size = 40 }) {
  return (
    <svg viewBox="0 0 100 100" width={size} height={size} className="flex-shrink-0">
      <rect width="100" height="100" rx="16" fill="#FF9900" />
      <text x="50" y="45" textAnchor="middle" fill="white" fontSize="22" fontWeight="bold" fontFamily="Arial">amazon</text>
      <path d="M25 55 Q50 70 75 55" fill="none" stroke="white" strokeWidth="4" strokeLinecap="round" />
      <path d="M68 52 L75 55 L72 62" fill="none" stroke="white" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function AliExpressLogo({ size = 40 }) {
  return (
    <svg viewBox="0 0 100 100" width={size} height={size} className="flex-shrink-0">
      <rect width="100" height="100" rx="16" fill="#E62E04" />
      <text x="50" y="40" textAnchor="middle" fill="white" fontSize="16" fontWeight="bold" fontFamily="Arial">Ali</text>
      <text x="50" y="60" textAnchor="middle" fill="white" fontSize="14" fontWeight="bold" fontFamily="Arial">Express</text>
      <circle cx="50" cy="78" r="4" fill="#FFD700" />
    </svg>
  );
}

export function TemuLogo({ size = 40 }) {
  return (
    <svg viewBox="0 0 100 100" width={size} height={size} className="flex-shrink-0">
      <rect width="100" height="100" rx="16" fill="#F26522" />
      <text x="50" y="58" textAnchor="middle" fill="white" fontSize="28" fontWeight="900" fontFamily="Arial" letterSpacing="-1">Temu</text>
      <circle cx="28" cy="30" r="6" fill="white" opacity="0.3" />
      <circle cx="72" cy="25" r="4" fill="white" opacity="0.2" />
    </svg>
  );
}

export function EbayLogo({ size = 40 }) {
  return (
    <svg viewBox="0 0 100 100" width={size} height={size} className="flex-shrink-0">
      <rect width="100" height="100" rx="16" fill="#FFFFFF" stroke="#E0E0E0" strokeWidth="2" />
      <text x="12" y="62" fill="#E53238" fontSize="32" fontWeight="bold" fontFamily="Arial" fontStyle="italic">e</text>
      <text x="32" y="62" fill="#0064D2" fontSize="32" fontWeight="bold" fontFamily="Arial" fontStyle="italic">b</text>
      <text x="54" y="62" fill="#F5AF02" fontSize="32" fontWeight="bold" fontFamily="Arial" fontStyle="italic">a</text>
      <text x="76" y="62" fill="#86B817" fontSize="32" fontWeight="bold" fontFamily="Arial" fontStyle="italic">y</text>
    </svg>
  );
}

export function WalmartLogo({ size = 40 }) {
  return (
    <svg viewBox="0 0 100 100" width={size} height={size} className="flex-shrink-0">
      <rect width="100" height="100" rx="16" fill="#0071CE" />
      <g transform="translate(50,38)">
        {[0, 60, 120, 180, 240, 300].map((angle, i) => (
          <ellipse key={i} cx="0" cy="-12" rx="3.5" ry="10" fill="#FFC220"
            transform={`rotate(${angle})`} />
        ))}
      </g>
      <text x="50" y="72" textAnchor="middle" fill="white" fontSize="13" fontWeight="bold" fontFamily="Arial">Walmart</text>
    </svg>
  );
}

export function NoonLogo({ size = 40 }) {
  return (
    <svg viewBox="0 0 100 100" width={size} height={size} className="flex-shrink-0">
      <rect width="100" height="100" rx="16" fill="#FEEE00" />
      <text x="50" y="62" textAnchor="middle" fill="#222222" fontSize="34" fontWeight="900" fontFamily="Arial">noon</text>
      <rect x="78" y="42" width="6" height="6" rx="3" fill="#222222" />
    </svg>
  );
}

// Map marketplace id to logo component
const LOGO_MAP = {
  amazon: AmazonLogo,
  aliexpress: AliExpressLogo,
  temu: TemuLogo,
  ebay: EbayLogo,
  walmart: WalmartLogo,
  noon: NoonLogo,
};

export function MarketplaceLogo({ marketplaceId, size = 40 }) {
  const LogoComponent = LOGO_MAP[marketplaceId];
  if (LogoComponent) {
    return <LogoComponent size={size} />;
  }
  // Fallback
  return (
    <div
      style={{ width: size, height: size, borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: size * 0.45, fontWeight: 'bold', color: '#fff', backgroundColor: '#666' }}
    >
      {marketplaceId?.charAt(0)?.toUpperCase()}
    </div>
  );
}

export default MarketplaceLogo;
